const CardData35 =[
    
    {
        title: 'Fernando Delgadillo',
        description:
          'Fernando Delgadillo González (Tlalnepantla, 11 de noviembre de 1965) es un cantautor mexicano del género trova o nueva canción. Estudió en la Escuela de Música Libre José F. Vázquez y en la escuela de la Sociedad de Autores y Compositores de México. A los 16 años fue percusionista en una agrupación de música andina llamada Huancayo, con los cuales se presentaba en la peña El Sapo Cancionero;4​ e integró el colectivo SEYMUS.1​ Comenzó actividad artística en 1985. En 1997, Delgadillo fue invitado a China para participar en el Beijing International Film Festival. Después de dicho festival, algunas de sus canciones fueron traducidas al chino. Más tarde, en agosto, lo invitaron al Festival Internacional de la Juventud, con sede en La Habana, Cuba',
        category: 'Trova',
        videourl:
          'https://www.youtube.com/playlist?list=OLAK5uy_nzInDmkRTLzFkkj-lLHjOvQj9YpR9rKug',
        price: 80,
        coverImg: 'fernandodelgadillo.jpg',
        location: 'Mexico',
        locationImg: 'mexiflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.fdelgadillo.com.mx/',
        youtube: 'https://www.youtube.com/channel/UCVeaNTYY8SGCMqiY31Kc-tA',
        facebook: 'https://www.facebook.com/FernandoDelgadilloOficial/',
        instagram: 'https://www.instagram.com/fernandodelgadillooficial/?hl=es-la',
        twitter: 'https://x.com/DelgadilloFer',
        spotify:
          'https://open.spotify.com/artist/12GqGscKJx3aE4t07u7eVZ?si=u4gDkNCrR_-gnhy-aFtWJQ&nd=1',
        deezer: 'https://www.deezer.com/mx/artist/14801',
        apple: 'https://music.apple.com/mx/artist/fernando-delgadillo/145982983',
        soundcloud: 'https://soundcloud.com/search?q=Fernando%20Delgadillo',
        tidal: 'https://listen.tidal.com/artist/4159503',
        wiki: 'https://es.wikipedia.org/wiki/Fernando_Delgadillo',
        ticketmaster:
          'https://www.ticketmaster.com/fernando-delgadillo-tickets/artist/1174042',
        tiktok: 'https://www.tiktok.com/search?q=Fernando%20Delgadillo&t=1726170971501',
        napster: 'https://music.amazon.com.mx/artists/B000QKD32G/fernando-delgadillo',
      },
      {
        title: 'Silvio Rodriguez',
        description:
          'Silvio Rodríguez Domínguez (San Antonio de los Baños, Cuba; 29 de noviembre de 1946), conocido como Silvio Rodríguez, El Aprendiz o El Escaramujo, es un cantautor, guitarrista, poeta y político cubano, exponente característico de la música de su país surgida con la Revolución cubana, conocida como la Nueva Trova, que comparte con otros reconocidos cantautores tales como Pablo Milanés, Noel Nicola y Vicente Feliú.',
      
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_nkSWrqjiIW2Mpw5SUNiDlPF9Llu9nx7TY&si=EuoZqgCVG25ZJgDO',
        price: '$50',
        coverImg: 'sylvio.jpg',
        category: 'Trova',
        location: 'Cuba',
        locationImg: 'cubaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.zurrondelaprendiz.com/',
        youtube: 'https://www.youtube.com/channel/UC16aF70kysMIJdz51HdMx9Q',
        facebook: 'https://www.facebook.com/zurrondelaprendiz',
        instagram: 'https://www.instagram.com/zurron_del_aprendiz',
        twitter: 'https://x.com/zurron_aprendiz',
        spotify: 'https://open.spotify.com/artist/4rUyBlggM5tZUH5QZn9ZuO',
        deezer: 'https://www.deezer.com/mx/artist/4340',
        apple: 'https://music.apple.com/mx/artist/silvio-rodr%C3%ADguez/303508',
        soundcloud: 'https://soundcloud.com/silviorodriguezofficial',
        tidal: 'https://listen.tidal.com/artist/3521820',
        wiki: 'https://es.wikipedia.org/wiki/Silvio_Rodr%C3%ADguez',
        ticketmaster:'https://www.ticketmaster.com/silvio-rodriguez-tickets/artist/1171066',
        tiktok: 'https://www.tiktok.com/@silviorodriguesmusic',
        napster: 'https://music.amazon.com.mx/artists/B000QKFHVQ/silvio-rodr%C3%ADguez',
      },
      {
        title: 'Pablo Milanes',
        description:
          'Pablo Milanés Arias (Bayamo, 24 de febrero de 1943-Madrid, 22 de noviembre de 2022) Nació en Bayamo, provincia de Oriente, actual provincia de Granma, Cuba. Estudió música en el Conservatorio Municipal de La Habana. En sus comienzos estuvo muy influido por la música tradicional cubana y por el feeling (sentimiento, en inglés). El feeling es un estilo musical que se inició en Cuba en los años 1940 y suponía una nueva manera de afrontar la canción, donde el sentimiento definía la interpretación y estaba influido por las corrientes estadounidenses de la canción romántica y del jazz. El feeling se acompañaba de una guitarra, al estilo de los viejos trovadores pero enriquecido por armonizaciones jazzísticas. Así se establecía esta nueva forma de comunicación o "feeling" con el público.',
      
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_l47ADXdJJJQvnrxx6LkL9dNH30KN1aa84&si=A10mr6MWXZqDMWjO',
        price: '$50',
        coverImg: 'pablomilanes.jpg',
        category: 'Trova',
        location: 'Cuba',
        locationImg: 'cubaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.milanespablo.com/',
        youtube: 'https://www.youtube.com/channel/UCg1l44T5Irwm5K849uO9Hiw',
        facebook: 'https://www.facebook.com/pmilanesoficial',
        instagram: 'https://www.instagram.com/pablo_milanes_oficial/',
        twitter: 'https://x.com/pmilanesoficial',
        spotify: 'https://open.spotify.com/artist/4vOfKh5wz7lTcdqB3EwsC5',
        deezer: 'https://www.deezer.com/mx/artist/75087',
        apple: 'https://music.apple.com/mx/artist/pablo-milan%C3%A9s/132280',
        soundcloud: 'https://soundcloud.com/pablomilanes',
        tidal: 'https://listen.tidal.com/artist/35825',
        wiki: 'https://es.wikipedia.org/wiki/Pablo_Milan%C3%A9s',
        ticketmaster:'https://www.ticketmaster.com/pablo-milanes-tickets/artist/762879',
        tiktok: 'https://www.tiktok.com/search/video?q=Pablo%20Milanes&t=1726169450082',
        napster: 'https://music.amazon.com.mx/artists/B000QKA3M4/pablo-milan%C3%A9s',
      },
      {
        title: 'Joan Manuel Serrat',
        description:
          'Joan Manuel Serrat Teresa​ (Barcelona; 27 de diciembre de 1943), conocido como Joan Manuel Serrat, es un cantautor, compositor, actor, escritor, poeta y guitarrista español, premiado con la Gran Cruz de la Orden Civil de Alfonso X el Sabio «por su brillante carrera y su contribución a la cultura y el arte españoles»​ y el Premio Princesa de Asturias de las Artes 2024, por un "trabajo (que), de honda raíz mediterránea, se aúna el arte de la poesía y la música al servicio de la tolerancia, los valores compartidos, la riqueza de la diversidad de lenguas y culturas, así como un necesario afán de libertad.',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_mbCNJwbFM-XfK9t4POOH3x-KUDo4h3PI8&si=ZEVODxPoEz-0vasN',
        price: 80,
        coverImg: 'joanmanuelserrat.jpg',
        location: 'España',
        locationImg: 'spain.jpeg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.fdelgadillo.com.mx/',
        youtube: 'https://www.youtube.com/channel/UC9twmdozj_iXRhX_FRZMwzw',
        facebook: 'https://www.facebook.com/joanmanuelserrat.oficial',
        instagram: 'https://www.instagram.com/joanmanuelserrat/',
        twitter: 'https://x.com/SerratEscribe',
        spotify:
          'https://open.spotify.com/artist/1t7t8q4zoYHp22JLIx3FM7',
        deezer: 'https://www.deezer.com/mx/artist/3289',
        apple: 'https://music.apple.com/mx/artist/joan-manuel-serrat/6604936',
        soundcloud: 'https://soundcloud.com/joan-manuel-serrat-official',
        tidal: 'https://listen.tidal.com/artist/4588',
        wiki: 'https://es.wikipedia.org/wiki/Joan_Manuel_Serrat',
        ticketmaster:
          'https://www.ticketmaster.com/joan-manuel-serrat-tickets/artist/1171021',
        tiktok: 'https://www.tiktok.com/@joan.mauelserrat',
        napster: 'https://music.amazon.com.mx/artists/B000QKP4BE/joan-manuel-serrat',
      },
      {
        title: 'Victor Heredia',
        description:
          'Víctor Ramón Cournou Heredia (Buenos Aires, 24 de enero de 1947), conocido como Víctor Heredia, es un cantautor, poeta, escritor y trovador argentino cuyas composiciones regularmente tratan sobre el amor, la paz y la libertad.Víctor nació en el barrio Monserrat de la ciudad de Buenos Aires. Su familia paterna (Cournou) es de origen francés, mientras que su abuela materna pertenecía a la etnia capayán y había nacido en los valles calchaquíes de la provincia de Catamarca. Si bien comenzó su educación escolar en su barrio natal, a los 9 años se mudó con su familia a la población de Paso del Rey (al oeste del Gran Buenos Aires) donde ingresó a la Escuela 18, donde terminó la primaria.',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_kHpi7PSxNQqjk5ErOB9mVsTcRrFk6XGH8&si=KkM7AYsFnHQiPnEn',
        price: 80,
        coverImg: 'victorheredia.jpg',
        location: 'Argentina',
        locationImg: 'argentinaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.victorherediaweb.com.ar/',
        youtube: 'https://www.youtube.com/channel/UCgyz6JnYiCJ8Zr4mbmn4ckQ',
        facebook: 'https://www.facebook.com/victorheredia.oficial',
        instagram: 'https://www.instagram.com/joanmanuelserrat/',
        twitter: 'https://x.com/VictorHerediaOK',
        spotify:
          'https://open.spotify.com/artist/07S2B15CcvWG4jyfMhqx8X',
        deezer: 'https://www.deezer.com/mx/artist/361665',
        apple: 'https://music.apple.com/mx/artist/joan-manuel-serrat/6604936',
        soundcloud: 'https://soundcloud.com/joan-manuel-serrat-official',
        tidal: 'https://listen.tidal.com/artist/4588',
        wiki: 'https://es.wikipedia.org/wiki/V%C3%ADctor_Heredia',
        ticketmaster:
          'https://www.viagogo.com/ar/Entradas-Conciertos/Latin/Victor-Heredia-Entradas',
        tiktok: 'https://www.tiktok.com/search/video?q=Victor%20Heredia&t=1726172840343',
        napster: 'https://music.amazon.com.mx/artists/B000QKTYHE/victor-heredia',
      },
      {
        title: 'Guadalupe Pineda',
        description:
          'María Guadalupe Pineda Aguilar (Guadalajara, Jalisco, 23 de febrero de 1955) es una cantante mexicana, cuya privilegiada voz y estilo han marcado el panorama musical de México y Latinoamérica.​ Ganadora del Grammy Latino a la Excelencia Musical, ha grabado más de 30 discos con más de 14 millones de copias vendidas.​ Su versatilidad y fuerza interpretativa la han convertido en una de las voces favoritas y más reconocidas de México.​ En 1984, graba el tema "Yolanda" (más conocido como "Te Amo"), que la lanza definitivamente al gran público, logrando vender un millón y medio de discos, adquiriendo una creciente popularidad entre las nuevas voces jóvenes de la canción en México.​ Merecedora de innumerables premios, varios discos de oro y platino, y menciones especiales por parte de la crítica, Guadalupe es siempre un punto de encuentro para quienes gustan de la buena música',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=UULFMR-v0Rj8aeBUbdkJoX2bFA&si=thg90VWH_dO09v9d',
        price: 80,
        coverImg: 'guadalupepineda.jpg',
        location: 'Mexico',
        locationImg: 'mexiflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://guadalupepineda.com/',
        youtube: 'https://www.youtube.com/channel/UCgyz6JnYiCJ8Zr4mbmn4ckQ',
        facebook: 'https://www.facebook.com/GuadalupePineda',
        instagram: 'https://www.instagram.com/guadalupepinedaa',
        twitter: 'https://x.com/GuadalupePineda',
        spotify:
          'https://open.spotify.com/artist/6xG6oz3V8nZWrwSqpZmPii',
        deezer: 'https://www.deezer.com/mx/artist/244055',
        apple: 'https://music.apple.com/mx/artist/guadalupe-pineda/148131217',
        soundcloud: 'https://soundcloud.com/guadalupepineda-music',
        tidal: 'https://listen.tidal.com/artist/3586981',
        wiki: 'https://es.wikipedia.org/wiki/Guadalupe_Pineda',
        ticketmaster:
          'https://www.viagogo.com/ar/Entradas-Conciertos/Otros-Conciertos/Guadalupe-Pineda-Entradas',
        tiktok: 'https://www.tiktok.com/search/video?q=Guadalupe%20Pineda',
        napster: 'https://music.amazon.com.mx/artists/B000QKA76Q/guadalupe-pineda',
      },
      {
        title: 'Facundo Cabral',
        description:
          'Rodolfo Enrique Cabral Camiñas (La Plata, 22 de mayo de 1937 - Ciudad de Guatemala, 9 de julio de 2011), conocido por su nombre artístico Facundo Cabral, en sus inicios como Indio Gasparino, fue un cantautor, poeta, escritor y filósofo argentino.Su propuesta artística resulta difícil de encasillar. Aunque compuso canciones y algunas de estas trascendieron a nivel hispanoamericano como «No soy de aquí ni soy de allá», su obra también consistía en contar historias con una estética que entremezclaba la crítica social, sátira, misticismo, cristianismo, anarquismo, optimismo, hedonismo y libertad. En ellas citaba constantemente a Jesús, Atahualpa Yupanqui, Krishnamurti, Borges, Whitman y Teresa de Calcuta, entre otros.',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_k7XRgN7MV9P76t6sEDfq0qLYGpxUczOxE&si=lVItEntnd1TLb8gT',
        price: 80,
        coverImg: 'facundocabral.png',
        location: 'Guatemala',
        locationImg: 'guatemalaflag.jpeg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.fundacionfacundocabral.com/',
        youtube: 'https://www.youtube.com/channel/UCGQrmIJUUY-OliERiaK92tA',
        facebook: 'https://www.facebook.com/facundocabralofficial',
        instagram: 'https://www.instagram.com/facundocabralofficial',
        twitter: 'https://x.com/facundocabral',
        spotify:
          'https://open.spotify.com/artist/1vCCUwNiIwC41lEu7EuBmx',
        deezer: 'https://www.deezer.com/mx/artist/115378',
        apple: 'https://music.apple.com/mx/artist/facundo-cabral/16613375',
        soundcloud: 'https://soundcloud.com/facundo-cabral-official',
        tidal: 'https://listen.tidal.com/artist/3512937',
        wiki: 'https://es.wikipedia.org/wiki/Facundo_Cabral',
        ticketmaster:
          'http://www.ticketexpress.com.do/ShowEvent.aspx?ID=211',
        tiktok: 'https://www.tiktok.com/@facundocabraloficial',
        napster: 'https://music.amazon.com.mx/artists/B0013ROFQE/facundo-cabral',
      },
      {
        title: 'Alfredo Zitarrosa',
        description:
          'Alfredo Zitarrosa (Montevideo, 10 de marzo de 1936-Montevideo, 17 de enero de 1989) fue un cantautor, poeta, escritor, locutor y periodista uruguayo, considerado una de las figuras más destacadas de la música popular de su país y de toda América Latina',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_nku9p0ea4z1Y_zJ6_g0noasUixn_TRW0Q&si=6MpDjMzeM5xiepZt',
        price: 80,
        coverImg: 'alfredozitarrosa.png',
        location: 'Uruguay',
        locationImg: 'uruguayflag.png',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.zitarrosa.org/',
        youtube: 'https://www.youtube.com/channel/UCk5vgkmmsZMnHsuofxnqh4A',
        facebook: 'https://www.facebook.com/profile.php?id=100044083256041',
        instagram: 'https://www.instagram.com/zitarrosa_alfredo_/',
        twitter: 'https://x.com/AlfZitarrosa',
        spotify:
          'https://open.spotify.com/artist/4xQFKlQXtzYxfZOnk799m2',
        deezer: 'https://www.deezer.com/mx/artist/821587',
        apple: 'https://music.apple.com/mx/artist/alfredo-zitarrosa/33251395',
        soundcloud: 'https://soundcloud.com/alfredozitarrosa',
        tidal: 'https://listen.tidal.com/artist/3658402',
        wiki: 'https://es.wikipedia.org/wiki/Alfredo_Zitarrosa',
        ticketmaster:
          'https://www.wegow.com/mx/artistas/alfredo-zitarrosa',
        tiktok: 'https://www.tiktok.com/search/video?q=Alfredo%20Zitarrosa&t=1726176129413',
        napster: 'https://music.amazon.com.mx/artists/B000QJPDNO/alfredo-zitarrosa',
      },
      {
        title: 'Mercedes Sosa',
        description:
          'Haydée Mercedes Sosa (San Miguel de Tucumán, Tucumán, 9 de julio de 1935-Buenos Aires, 4 de octubre de 2009)​ fue una cantante de música folclórica argentina, considerada la mayor exponente del folclore argentino. Se la conoció como la voz de América Latina.Fundadora del Movimiento del Nuevo Cancionero y una de las exponentes de la Nueva Canción Latinoamericana, incursionó en otros géneros como el tango, el rock y el pop. Se definía a sí misma como «cantora» antes que «cantante», siendo una distinción fundamental de la nueva canción latinoamericana de la que ella fue una de las iniciadoras: «Cantante es el que puede y cantor el que debe» (Facundo Cabral).',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_klY4m6Fz_O2mDSJf9jqO_YLtufD4uoM64&si=SfVSVKrFiefNJ1PR',
        price: 80,
        coverImg: 'mercedessosa.jpg',
        location: 'Uruguay',
        locationImg: 'argentinaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://www.zitarrosa.org/',
        youtube: 'https://www.youtube.com/channel/UCetq_ZOSLiWxiwNXMniNR9g',
        facebook: 'https://www.facebook.com/mercedes.sosaok',
        instagram: 'https://www.instagram.com/mercedes.sosaok/',
        twitter: 'https://x.com/sosa_folk',
        spotify:'https://open.spotify.com/artist/2HvyR5FsU37QMqVzIbGwl7',
        deezer: 'https://www.deezer.com/mx/artist/10606',
        apple: 'https://music.apple.com/mx/artist/mercedes-sosa/122968',
        soundcloud: 'https://soundcloud.com/mercedes-sosa-official',
        tidal: 'https://listen.tidal.com/artist/3501549',
        wiki: 'https://es.wikipedia.org/wiki/Mercedes_Sosa',
        ticketmaster:
          'https://www.tomaticket.es/es-es/artista/mercedes-sosa/mexico',
        tiktok: 'https://www.tiktok.com/search/video?q=Mercedes%20Sosa&t=1726177072798',
        napster: 'https://music.amazon.com.mx/artists/B000QKLUGM/mercedes-sosa',
      },
      {
        title: 'Maria Teresa Vera',
        description:
          'María Teresa Vera (Guanajay, Cuba, 6 de febrero de 1895-La Habana, 17 de diciembre de 1965) fue una cantante, compositora y guitarrista cubana. A muy temprana edad, empezó a darse a conocer en los ambientes de bohemia y trova. Comenzó a cantar en 1911, y el cantante Manuel Corona le aconsejó que aprendiera a tocar la guitarra. María Teresa conformó un dúo de leyenda junto a Rafael Zequeira y, entre 1914 y 1924, grabaron casi 200 canciones, muchas de las cuales se hicieron populares de inmediato, como A llorar a Papá Montero. También cantó en el Grupo Típico de Carlos Godínez.',
        category: 'Trova',
        videourl:
          'https://youtube.com/playlist?list=OLAK5uy_mkP39Po5FbvBZllWDDY_A6ATdbfU-xF5g&si=IyqHuon3hsJrFUEn',
        price: 80,
        coverImg: 'mariavera.jpeg',
        location: 'Cuba',
        locationImg: 'cubaflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://elpais.com/cultura/2020/02/06/actualidad/1580983162_031578.html',
        youtube: 'https://www.youtube.com/channel/UC0ltJ50htfhtIQXkm4X3JTg',
        facebook: 'https://www.facebook.com/hashtag/trova',
        instagram: 'https://www.instagram.com/p/C_OMjVpod-B/?locale=%E5%93%AA%E9%87%8C%E8%83%BD%E5%81%9A%E4%BC%8A%E6%8B%89%E5%85%8B%E4%B8%93%E5%88%A9%E8%AF%81%E4%B9%A6%E8%81%94%E7%B3%BB%7B%E5%A8%81%E4%BF%A1%2BTG%2F%E9%A3%9E%E6%9C%BA%3A%40buth2788%7DMJkey%3F%3F%3F%3F%3F%3F%D1%A7%3F%3F%C6%BEJnHlF',
        twitter: 'https://x.com/search?q=Maria%20Teresa%20Vera&src=typed_query&f=media',
        spotify:'https://open.spotify.com/artist/0K2uwmxSdZBPHmtBz54ELR',
        deezer: 'https://www.deezer.com/mx/artist/250506',
        apple: 'https://music.apple.com/mx/artist/mar%C3%ADa-teresa-vera/3736008',
        soundcloud: 'https://soundcloud.com/mariateresavera-scmusic',
        tidal: 'https://listen.tidal.com/artist/3612716',
        wiki: 'https://es.wikipedia.org/wiki/Mar%C3%ADa_Teresa_Vera',
        ticketmaster:
          'https://www.eticket.mx/eventos.aspx?idlugar=966',
        tiktok: 'https://www.tiktok.com/search/video?q=Maria%20Teresa%20Vera&t=1726177615284',
        napster: 'https://music.amazon.com.mx/artists/B000QJPT4C/maria-teresa-vera',
      },
      {
        title: 'Pepe Jara',
        description:
          'José Jesús Jara Martínez (Ciudad Madero, 25 de diciembre de 1928 - Ciudad de México, 30 de julio de 2005), más conocido como Pepe Jara, o El Trovador Solitario, fue un cantante mexicano de boleros, y el principal intérprete del compositor oaxaqueño Álvaro Carrillo.Pepe Jara desde pequeño se fue a vivir a Chihuahua, pero a los 19 años, en 1947 se fue a radicar a la capital mexicana. En la década de 1950 los tríos estaban en apogeo, por lo que se integró a algunos de ellos como Los Pepes, el Culiacán y Los Duendes',
        category: 'Trova',
        videourl:
         'https://youtube.com/playlist?list=OLAK5uy_mJZlL-iwwe0Rm0Ci_aWXZAR0nXGlhIpKU&si=6JeM8CHcJGzEftm3',
        price: 80,
        coverImg: 'pepejara.jpeg',
        location: 'Mexico',
        locationImg: 'mexiflag.jpg',
        openSpots: null,
        likes: 1000,
        websiteurl: 'https://elpais.com/cultura/2020/02/06/actualidad/1580983162_031578.html',
        youtube: 'https://www.youtube.com/channel/UCju-bUypsYr-f4Omx20SYDg',
        facebook: 'https://www.facebook.com/MexTunes',
        instagram: 'https://www.instagram.com/_mextunes_',
        twitter: 'https://www.tiktok.com/@mextunes',
        spotify:'https://open.spotify.com/artist/6OgrmJe15LhZrdbRQxE2Bl',
        deezer: 'https://www.deezer.com/mx/artist/353338',
        apple: 'https://music.apple.com/mx/artist/pepe-jara/1246879578',
        soundcloud: 'https://soundcloud.com/pepejaraofficial',
        tidal: 'https://listen.tidal.com/artist/3660054',
        wiki: 'https://es.wikipedia.org/wiki/Pepe_Jara',
        ticketmaster:
          'https://www.eticket.mx/eventos.aspx?idlugar=966',
        tiktok: 'https://www.tiktok.com/@mextunes',
        napster: 'https://music.amazon.com.mx/artists/B001BHE1EC/pepe-jara',
      },
]
export default CardData35;